import vhCheck from 'vh-check';

import 'mdn-polyfills/Array.prototype.find';
import 'mdn-polyfills/Element.prototype.closest';
import 'mdn-polyfills/NodeList.prototype.forEach';

import 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/blur-up/ls.blur-up';

/*
 * Gievs us 1 viewport height unit as a css variable called '--vh'
 * Usage example: height: calc(var(--vh, 1vh) * 100);
 * https://github.com/Hiswe/vh-check/blob/master/README.md
 */
vhCheck({
	redefineVh: true,
});
